import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';


import { TranslateModule } from '@ngx-translate/core';
import { RequestExactAlarmPageRoutingModule } from './request-exact-alarm-routing.module';
import { RequestExactAlarmModalPage } from './request-exact-alarm.modal.page';



@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, RequestExactAlarmPageRoutingModule, TranslateModule.forChild()],
  declarations: [RequestExactAlarmModalPage]
})
export class RequestExactAlarmPageModule {}
